import { useState } from 'react';

var useAccordionAnimation = function useAccordionAnimation(ref) {
  var _useState = useState(0),
      boxHeight = _useState[0],
      setBoxHeight = _useState[1];
  /* before opened false */


  var handleExiting = function handleExiting() {
    setBoxHeight(0);
  };
  /* before opened true */


  var handleEntering = function handleEntering() {
    var _ref$current;

    var height = ref == null ? void 0 : (_ref$current = ref.current) == null ? void 0 : _ref$current.scrollHeight;

    if (height !== undefined) {
      setBoxHeight(height);
    }
  };

  return {
    boxHeight: boxHeight,
    handleExiting: handleExiting,
    handleEntering: handleEntering
  };
};

export { useAccordionAnimation };
